import { CommonModule, DatePipe } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../services/app.service';
import { SettingsService } from '../../services/settings.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';
import { InstructionsComponent } from '../instructions/instructions.component';
import { Setting } from '../../classes/setting';

@Component({
    selector: 'app-instructions-wrapper',
    templateUrl: './instructions-wrapper.component.html',
    standalone: true,
    imports: [
        MatButtonModule,
        MatDividerModule,
        MatCheckboxModule,
        FormsModule,
        MatCardModule,
        CommonModule,
        InstructionsComponent
    ],
})
export class InstructionsWrapperComponent implements OnInit {

    protected readonly appSvc = inject(AppService);
    protected readonly datePipe = inject(DatePipe);
    protected readonly destroyRef = inject(DestroyRef);
    protected readonly route = inject(ActivatedRoute);
    protected readonly router = inject(Router);
    protected readonly settingSvc = inject(SettingsService);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);

    instructionsRead = false;
    settings: Setting[] | null = null;
    user: UserInfo | null = null;

    ngOnInit() {
        this.getSettings();
        this.user = this.userSvc.User;
    }

    getSettings() {
        this.settingSvc.SettingsSubject.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((settings) => {
            this.settings = settings;
        });
    }

    handleInstructionsAction(route: string) {
        if (!route) return;

        // If we're going to the application page, then we need to mark instructions as read.
        if (route === 'student-application') {
            this.appSvc
                .ReadInstructions({
                    StudentID: this.userSvc.User.StudentID,
                })
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe({
                    next: (res) => {
                        this.router.navigate(['student-application']);
                    },
                    error: (err) => {
                        this.snackBarSvc.error(err.error, 10000);
                    },
                });
        } else {
            // Route instead to the provided route.
            this.router.navigate([route]);
        }
    }
}
